import {
  Button,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  VStack,
  Divider,
} from '@chakra-ui/react';
import { ChevronDownIcon, AddIcon } from '@chakra-ui/icons';
import { DndContext, closestCorners } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { SortableMenuItem } from './sortable-menu-item';
import { ColumnManagerProps } from './types';

const ColumnManager = ({
  columns,
  columnVisibility,
  fixedColumns,
  sensors,
  onDragEnd,
  onToggleVisibility,
  onEditColumn,
  onDeleteColumn,
  onAddColumn,
}: ColumnManagerProps) => (
  <Popover placement="bottom-end" variant="primary">
    <PopoverTrigger>
      <Button
        rightIcon={<ChevronDownIcon />}
        variant="secondary"
        textAlign="left"
      >
        All columns
      </Button>
    </PopoverTrigger>
    <PopoverContent p={2}>
      <PopoverBody p={0}>
        <DndContext
          sensors={sensors}
          collisionDetection={closestCorners}
          onDragEnd={onDragEnd}
        >
          <SortableContext
            items={columns
              .filter(col => !fixedColumns.includes(col.id))
              .map(col => col.id)}
            strategy={verticalListSortingStrategy}
          >
            <VStack align="stretch" spacing={2}>
              {columns
                .filter(col => !fixedColumns.includes(col.id))
                .map((column) => (
                  <SortableMenuItem
                    key={column.id}
                    id={column.id}
                    column={column}
                    isVisible={columnVisibility[column.id]}
                    onToggleVisibility={() => onToggleVisibility(column.id)}
                    onEdit={() => onEditColumn(column)}
                    onDelete={() => onDeleteColumn(column.id)}
                  />
                ))}
            </VStack>
          </SortableContext>
        </DndContext>
        {columns.length > 2 && <Divider my={2} />}
        <Button
          variant="ghost"
          width="100%"
          leftIcon={<AddIcon />}
          justifyContent="flex-start"
          onClick={onAddColumn}
        >
          Add column
        </Button>
      </PopoverBody>
    </PopoverContent>
  </Popover>
);

export default ColumnManager;